import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CloseIcon from "@mui/icons-material/Close";

export const ShareModal = ({
  onClose,
  onInstagram,
  onFacebook,
  onWhatsApp,
}: {
  onClose: () => void;
  onInstagram: () => void;
  onFacebook: () => void;
  onWhatsApp: () => void;
}) => {
  return (
    <div style={shareModalStyles.overlay} onClick={onClose}>
      <div style={shareModalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <button style={shareModalStyles.closeButton} onClick={onClose}>
          <CloseIcon style={shareModalStyles.closeIcon} />
        </button>
        <div style={shareModalStyles.title}>Share Photos</div>
        <div style={shareModalStyles.optionsContainer}>
          <button style={shareModalStyles.optionButton} onClick={onInstagram}>
            <InstagramIcon style={shareModalStyles.optionIconInstagram} />
            <span style={shareModalStyles.optionLabel}>Instagram</span>
          </button>
          <button style={shareModalStyles.optionButton} onClick={onFacebook}>
            <FacebookIcon style={shareModalStyles.optionIconFacebook} />
            <span style={shareModalStyles.optionLabel}>Facebook</span>
          </button>
          <button style={shareModalStyles.optionButton} onClick={onWhatsApp}>
            <WhatsAppIcon style={shareModalStyles.optionIconWhatsApp} />
            <span style={shareModalStyles.optionLabel}>WhatsApp</span>
          </button>
        </div>
      </div>
    </div>
  );
};

const shareModalStyles = {
  overlay: {
    position: "fixed" as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "24px",
    margin: "16px",
    maxWidth: "320px",
    width: "100%",
    position: "relative" as const,
  },
  closeButton: {
    position: "absolute" as const,
    top: "12px",
    right: "12px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  closeIcon: {
    fontSize: "24px",
    color: "#666",
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#0d2137",
    marginBottom: "24px",
    textAlign: "center" as const,
  },
  optionsContainer: {
    display: "flex",
    justifyContent: "space-around",
    gap: "16px",
  },
  optionButton: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    gap: "8px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "12px",
    borderRadius: "12px",
    transition: "background-color 0.2s",
    flex: 1,
  },
  optionIconInstagram: {
    fontSize: "40px",
    color: "#E4405F",
  },
  optionIconFacebook: {
    fontSize: "40px",
    color: "#1877F2",
  },
  optionIconWhatsApp: {
    fontSize: "40px",
    color: "#25D366",
  },
  optionLabel: {
    fontSize: "12px",
    color: "#0d2137",
    fontWeight: 500,
  },
};
